export enum BrandOrdersSource {
    BUGATTI = 'BUGATTI',
    SALAMANDER = 'SALAMANDER',
    BAGATT = 'BAGATT',
    DANIEL_HECHTER = 'DANIEL_HECHTER',
}
